export const APPLY_COUPON_ERROR = 'Sorry, there was an error adding your coupon.';
export const REMOVE_COUPON_ERROR = 'Sorry, there was an error removing your coupon.';
export const REMOVE_ALL_COUPONS_ERROR =
	'Sorry, there was an error removing your coupons. They are not allowed because some cart items have Ferguson account pricing';
export const REMOVE_ALL_COUPONS_SUCCESS = 'Coupons have been removed because some cart items have Ferguson account pricing.';
export const DISCOUNT_REMOVED = 'Discount successfully removed.';
export const EPP_DISCOUNT_APPLIED = 'EPP discounts successfully applied to your cart';
export const MASS_ADD_ITEM_REQUIRED = 'Please enter at least one product to add to cart.';
export const APPLE_PAY_US_ONLY = 'Sorry, we can only ship to US with Apple Pay.';
export const EMAIL_CART_ERROR = 'An error occurred while attempting to email your cart. Please try again';
export const EMAIL_CART_SUCCESS = 'Cart Sent! The cart has been submitted to the recipient via email';
export const EMAIL_CART_RECIPIENTS_LIMIT = 'Please enter no more than 5 recipients';
export const EMAIL_CART_RECIPIENT_EMAIL_INVALID = 'Please verify all recipient emails are valid';
export const LOAD_CART_ERROR = 'An error occurred while attempting to load your saved cart.';
export const PAYPAL_AUTHORIZATION_ERROR = 'Error authorizing with PayPal. Please try again.';
export const SAVE_CART_SUCCESS = 'Cart Saved Successfully.';
export const MISSING_BILLING_ADDRESS = 'A billing address is required.';
export const CART_PAGE_ERROR_MESSAGE = {
	SESSION_EXPIRED: 'Your session has expired.',
	INVALID_CHECKOUT_SESSION: 'There was an unexpected error. Please restart checkout and try again.',
	ORDER_NOT_FOUND: 'Sorry, we could not find that order, please try again.',
	ITEMS_NOT_FOUND: 'No cart items found',
	CART_EMPTY: 'Your cart is empty.',
	INVALID_CC_LINK_TOKEN:
		'There was an issue with your credit card link. Please request a new link from your customer service representative.'
};
